// extracted by mini-css-extract-plugin
export var statItem = "_i1-1";
export var statsRow = "_i1-0";